import {
  isNosugarBrowser,
} from "@/utils/nosugar";
import { appendAuthBootstrapToUrl } from "@/utils/storageHelper";

const DEFAULT_TARGET = "_blank";
const DEFAULT_REL = "noopener noreferrer";

function isBlankTarget(target) {
  return !target || target === DEFAULT_TARGET;
}

function resolveUrl(url) {
  if (typeof window === "undefined" || !url) {
    return null;
  }

  try {
    return new URL(url, window.location.href);
  } catch (e) {
    return null;
  }
}

function shouldPreserveOpener(url) {
  const resolvedUrl = resolveUrl(url);
  if (!resolvedUrl || typeof window === "undefined") {
    return false;
  }

  return resolvedUrl.origin === window.location.origin;
}

function tryNosugarOpen(url, target) {
  const resolvedUrl = resolveUrl(url);
  if (!resolvedUrl) {
    return false;
  }

  if (!isNosugarBrowser()) {
    return false;
  }

  // 检查是否有 nosugar.myapp.openUrl API
  if (typeof window !== "undefined" &&
      window.nosugar &&
      window.nosugar.myapp &&
      typeof window.nosugar.myapp.openUrl === "function") {
    try {
      console.log("[无糖]", "使用 nosugar.myapp.openUrl() 打开新页面");
      window.nosugar.myapp.openUrl(resolvedUrl.toString(), target || "_blank");
      return true;
    } catch (error) {
      console.warn("[无糖]", "nosugar.myapp.openUrl() 调用失败:", error);
      return false;
    }
  }

  console.log("[无糖]", "nosugar API 不可用，回退到 a 标签方式");
  return false;
}

export function openByAnchor(
  url,
  target = DEFAULT_TARGET,
  rel,
) {
  if (typeof document === "undefined" || !url) {
    return null;
  }

  console.log("[window.open] openByAnchor 调用", {
    原始URL: url,
    目标: target,
    是否无糖环境: isNosugarBrowser()
  });

  const finalUrl = appendAuthBootstrapToUrl(url);

  console.log("[window.open] URL 处理后", {
    处理后URL: finalUrl,
    是否添加了认证: finalUrl !== url
  });

  if (isBlankTarget(target) && tryNosugarOpen(finalUrl, target)) {
    console.log("[window.open] 使用无糖 API 打开成功");
    return null;
  }

  console.log("[window.open] 使用标准 <a> 标签方式打开");
  const link = document.createElement("a");
  link.href = finalUrl;
  link.target = target;
  const finalRel =
    typeof rel === "string"
      ? rel
      : shouldPreserveOpener(finalUrl)
        ? ""
        : DEFAULT_REL;
  if (finalRel) {
    link.rel = finalRel;
  }
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  return null;
}

export function openWindowCompat(url, target = DEFAULT_TARGET, features) {
  if (!url) {
    return null;
  }

  console.log("[window.open] openWindowCompat 调用", {
    url,
    target,
    features,
    是否无糖环境: isNosugarBrowser()
  });

  if (isBlankTarget(target)) {
    return openByAnchor(url, target);
  }

  return window.__nativeWindowOpen__(url, target, features);
}

export function installWindowOpenCompat() {
  if (typeof window === "undefined") {
    return;
  }

  if (window.__windowOpenCompatInstalled__) {
    console.log("[window.open] 兼容层已安装，跳过");
    return;
  }

  console.log("[window.open] 安装 window.open 兼容层", {
    是否无糖环境: isNosugarBrowser(),
    平台: navigator.platform
  });

  window.openByAnchor = openByAnchor;
  window.__nativeWindowOpen__ = window.open.bind(window);
  window.open = function patchedWindowOpen(url, target, features) {
    console.log("[window.open] 拦截到 window.open 调用", { url, target, features });
    if (isBlankTarget(target) && typeof url === "string" && url) {
      return openByAnchor(url, target);
    }
    return window.__nativeWindowOpen__(url, target, features);
  };
  window.__windowOpenCompatInstalled__ = true;
  console.log("[window.open] 兼容层安装完成");
}
